import { combineReducers } from 'redux';
import { issueListReducer, issueReducer } from './issue.reducer';
import issueCommentReducer from './issueComment.reducer';
import issueLogReducer from './issueLog.reducer';

import { SelectMultiPersonalDataCategoryReducer } from './selectMultiPersonalDataCategory.reducer';
import { SelectNameOrEmailReducer } from './selectNameOrEmail.reducer';
import {
  SelectDepartmentReducer,
  // SelectDepartment2Reducer,
  //  SelectDepartment3Reducer,
} from './selectDepartment.reducer';
import {
  SettingPermissionReducer,
  SettingPermissionDeleteReducer,
} from './settingPermission.reducer';
import {
  SettingPermissionManageReducer,
  SettingPermissionManageSaveReducer,
  SettingPermissionManageEditReducer,
  SettingPermissionManageByIdReducer,
} from './settingPermissionManage.reducer';
import {
  SettingLabelReducer,
  SettingLabelDeleteReducer,
} from './settingLabel.reducer';
import {
  SettingLabelManageReducer,
  SettingLabelManageSaveReducer,
  SettingLabelManageEditReducer,
  SettingLabelManageByIdReducer,
} from './settingLabelManage.reducer';

export default combineReducers({
 
  issueListReducer,
  issueReducer,
  issueCommentReducer,
  issueLogReducer,

  SelectMultiPersonalDataCategoryReducer,
  SelectNameOrEmailReducer,
  SelectDepartmentReducer,

  SettingPermissionReducer,
  SettingPermissionDeleteReducer,
  SettingPermissionManageReducer,
  SettingPermissionManageSaveReducer,
  SettingPermissionManageEditReducer,
  SettingPermissionManageByIdReducer,

  SettingLabelReducer,
  SettingLabelDeleteReducer,
  SettingLabelManageReducer,
  SettingLabelManageSaveReducer,
  SettingLabelManageEditReducer,
  SettingLabelManageByIdReducer,
});
